<template>
  <div class="edit-mortgage-parts-tab-content">
    <a-collapse v-if="!loading && mortgageParts.length > 0" activeKey="0">
      <a-collapse-panel v-for="(mortgagePart, index) in mortgageParts" :key="index"
                        :header="makeHeader(mortgagePart)"
      >
        <EditPartComponent @errorsCount="$emit('errorsCount',$event)" :mortgage-part-index="index" :enums="enums" :company-rates-list="companyRatesList" :loading="loading"></EditPartComponent>
      </a-collapse-panel>
    </a-collapse>
    <a-spin v-if="loading"></a-spin>
    <div style="margin: 1em 0" v-if="!loading">
      <a-button type="primary" @click="addNewMortgagePart" class="add-part">Leningdeel toevoegen</a-button>
    </div>
  </div>
</template>

<script>
import store from '~/store';
import mortgageStore from '~/modules/mortgage/store';
import {mapActions, mapGetters} from "vuex";
import mortgageApi from '~/api/mortgage';
import EditPartComponent from "./EditPartComponent";
import {toCurrency, toDate, toPercentage} from "~/plugins/string-helpers";

export default {
  name: 'MortgageEditPartsComponent',
  props: {
    mortgageId: {
      type: Number,
      required: false,
      default: null
    },
    customerId: Number,
    active: Boolean,
    isEditing: Boolean
  },
  components: {
    EditPartComponent
  },
  data() {
    return {
      loading: true,
      loadingNewMortgagePart: false,
      enums: [],
      companyRatesList: null
    }
  },
  created() {
    if (!store.hasModule('mortgage')) {
      store.registerModule('mortgage', mortgageStore)
    }

    if (!this.isEditing) {
      this.createEmptyMortgagePart();
    }
  },
  async mounted() {
    this.loading = true;
    try {
      if (!Array.isArray(this.mortgageParts) || this.mortgageParts.length === 0) {
        await this.fetchMortgageParts(this.mortgageId)
      }

      await this.fetchListsToCreateOrEdit(this.mortgageId)
    } catch (e) {
      this.$notification.error({
        message: 'Er is iets fout gegaan met het ophalen van de benodigde informatie',
        description: 'Probeer het opnieuw'
      })
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions('mortgage', [
      'fetchMortgageParts',
      'createEmptyMortgagePart'
    ]),
    addNewMortgagePart() {
      this.loadingNewMortgagePart = true;
      this.createEmptyMortgagePart(this.mortgageId);
      this.loadingNewMortgagePart = false;
    },
    async fetchListsToCreateOrEdit(mortgageId) {
      this.enums = await mortgageApi.getListsToCreateOrEdit(mortgageId);
    },
    makeHeader(mortgagePart) {
      if (!mortgagePart.exists) {
        return 'Nieuw leningdeel'
      }

      let rente = mortgagePart.rente || 0;

      let header = '';

      if (mortgagePart.leningdeelnummer) {
        header = header.concat(`#${mortgagePart.leningdeelnummer} / `)
      }

      header = header.concat(`${mortgagePart.repayment_type_description} / Hoofdsom: ${toCurrency(mortgagePart.hoofdsom)} / Restschuld: ${toCurrency(mortgagePart.remaining_debt)} / Rente: ${toPercentage(rente, 2)}`);

      if (mortgagePart.einddatumRentevast !== null) {
        header = header.concat(` / Einddatum rentevast: ${toDate(mortgagePart.einddatumRentevast, 'DD/MM/YYYY')}`);
      }

      return header;
    },
    async fetchHdnCompanyRates() {
      let financierAgencyId = this.mortgage.financier_agency_id;

      if (financierAgencyId)
        this.companyRatesList = await mortgageApi.getHdnCompanyRates(financierAgencyId)
    },
  },
  computed: {
    ...mapGetters({
      mortgage: 'mortgage/mortgage',
      mortgageParts: 'mortgage/mortgageParts'
    })
  },
  watch: {
    active: {
      immediate: true,
      handler(value) {
        if (value === true) {
          this.fetchHdnCompanyRates()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>